export const PackageIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4.66683V11.3335C14 13.3335 13 14.6668 10.6667 14.6668H5.33334C3 14.6668 2 13.3335 2 11.3335V4.66683C2 2.66683 3 1.3335 5.33334 1.3335H10.6667C13 1.3335 14 2.66683 14 4.66683Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.6665 3V4.33334C9.6665 5.06667 10.2665 5.66667 10.9998 5.66667H12.3332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3335 8.6665H8.00017"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3335 11.3335H10.6668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
